import {
  getV1CompaniesCompanyIdIamRoles,
  getV1IamRoles,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useCallback } from 'react';

import { RoleItem } from '~hooks/useUsers/models';
import connection from '~services/connectionModule';
import { useStores } from '~store';

export const useUserRoles = () => {
  const { userStore, userAdminStore } = useStores();

  const getUserRoles = useCallback(async () => {
    try {
      const response = await getV1IamRoles();
      const userRoles = response.data.data.map((item) => RoleItem.parse(item));

      userStore.setUserRoles(userRoles);
      userAdminStore.setUserRoles(userRoles);
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.user_roles.failed_to_fetch'),
      );
    }
  }, [userStore, userAdminStore]);

  const getCompanyUserRoles = useCallback(async (companyId: string) => {
    try {
      const response = await getV1CompaniesCompanyIdIamRoles({
        path: { 'company-id': companyId },
      });
      // Returned to caller; not written to userStore/userAdminStore — those are
      // populated by getUserRoles for app-wide consumers (UserForm, etc.) and
      // adding a second writer from a company-scoped endpoint risks divergence.
      return response.data.data.map((item) => RoleItem.parse(item));
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.user_roles.failed_to_fetch'),
      );
    }
  }, []);

  return { getUserRoles, getCompanyUserRoles };
};
